import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { proyectoService, clienteService, cotizacionService, configuracionService } from '../services/api';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const { usuario, esContratista, esCapataz, esAdmin } = useAuth();
  const [stats, setStats] = useState({
    proyectosActivos: 0,
    cotizacionesPendientes: 0,
    clientesTotales: 0,
    proyectosCompletados: 0
  });
  const [proyectos, setProyectos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [urlTienda, setUrlTienda] = useState('');

  useEffect(() => {
    cargarDatos();
    cargarUrlTienda();
  }, []);

  const cargarUrlTienda = async () => {
    try {
      const response = await configuracionService.getUrlTiendaLicencias();
      setUrlTienda(response.data.url);
    } catch (error) {
      console.error('Error al cargar URL de tienda:', error);
    }
  };

  const abrirTiendaLicencias = () => {
    if (urlTienda) {
      window.open(urlTienda, '_blank');
    } else {
      alert('La tienda de licencias no está configurada. Contacta al administrador.');
    }
  };

  const cargarDatos = async () => {
    try {
      if (esContratista || esAdmin) {
        const [proyectosRes, clientesRes, cotizacionesRes] = await Promise.all([
          proyectoService.getAll(),
          clienteService.getAll(),
          cotizacionService.getAll()
        ]);

        const proyectosActivos = proyectosRes.data.filter(p =>
          p.estado === 'en_curso' || p.estado === 'planificacion'
        );

        const proyectosCompletados = proyectosRes.data.filter(p =>
          p.estado === 'completado'
        );

        const cotizacionesPendientes = cotizacionesRes.data.filter(c =>
          c.estado === 'enviada' || c.estado === 'borrador'
        );

        setStats({
          proyectosActivos: proyectosActivos.length,
          cotizacionesPendientes: cotizacionesPendientes.length,
          clientesTotales: clientesRes.data.length,
          proyectosCompletados: proyectosCompletados.length
        });

        setProyectos(proyectosActivos.slice(0, 5));

      } else if (esCapataz) {
        const proyectosRes = await proyectoService.getAll();
        const proyectosActivos = proyectosRes.data.filter(p =>
          p.estado === 'en_curso'
        );

        setStats({
          proyectosActivos: proyectosActivos.length,
          proyectosCompletados: 0,
          cotizacionesPendientes: 0,
          clientesTotales: 0
        });

        setProyectos(proyectosActivos.slice(0, 5));
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <div>
            <h1>Bienvenido, {usuario?.nombre}</h1>
            <p>
              {esContratista && 'Panel de Control del Contratista'}
              {esCapataz && 'Panel de Control del Capataz'}
            </p>
          </div>
          {!esAdmin && (
            <button className="btn-tienda-licencias" onClick={abrirTiendaLicencias}>
              🛒 Tienda de Licencias
            </button>
          )}
        </div>
      </div>

      {esContratista && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#667eea' }}>📊</div>
            <div className="stat-info">
              <h3>{stats.proyectosActivos}</h3>
              <p>Proyectos Activos</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#f093fb' }}>📋</div>
            <div className="stat-info">
              <h3>{stats.cotizacionesPendientes}</h3>
              <p>Cotizaciones Pendientes</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#4facfe' }}>👥</div>
            <div className="stat-info">
              <h3>{stats.clientesTotales}</h3>
              <p>Clientes Totales</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#43e97b' }}>✓</div>
            <div className="stat-info">
              <h3>{stats.proyectosCompletados}</h3>
              <p>Proyectos Completados</p>
            </div>
          </div>
        </div>
      )}

      {esCapataz && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#667eea' }}>🏗️</div>
            <div className="stat-info">
              <h3>{stats.proyectosActivos}</h3>
              <p>Proyectos Asignados</p>
            </div>
          </div>
        </div>
      )}

      <div className="proyectos-recientes">
        <h2>
          {esContratista && 'Proyectos Activos Recientes'}
          {esCapataz && 'Mis Proyectos Asignados'}
        </h2>

        {proyectos.length === 0 ? (
          <p className="empty-message">No hay proyectos activos.</p>
        ) : (
          <div className="proyectos-list">
            {proyectos.map(proyecto => (
              <div key={proyecto.id} className="proyecto-card">
                <div className="proyecto-header">
                  <h3>{proyecto.nombre}</h3>
                  <span className={`estado-badge ${proyecto.estado}`}>
                    {proyecto.estado}
                  </span>
                </div>
                <p className="proyecto-cliente">Cliente: {proyecto.cliente_nombre}</p>
                {proyecto.capataz_nombre && (
                  <p className="proyecto-capataz">Capataz: {proyecto.capataz_nombre}</p>
                )}
                <div className="proyecto-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${proyecto.porcentaje_avance || 0}%` }}
                    ></div>
                  </div>
                  <span>{proyecto.porcentaje_avance || 0}%</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
